<template>
  <div class="section">
    <div v-if="title || required" class="head">
      <span>{{ title }}</span>
      <p v-if="requiredText || required">
        <span v-if="requiredText" class="required-text">{{ requiredText }}</span>
        <RequiredLabel v-if="required" />
      </p>
    </div>
    <hr v-else />
    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script>
import RequiredLabel from '@/components/molecules/RequiredLabel'

export default {
  name: 'FormSection',
  components: {
    RequiredLabel,
  },
  props: {
    /** セクションタイトル */
    title: String,
    /** 必須ラベル */
    required: Boolean,
    /** 必須ラベルの補助テキスト */
    requiredText: String,
  },
}
</script>

<style lang="postcss" scoped>
.head {
  align-items: center;
  background: var(--very-light-gray-2);
  display: flex;
  flex-wrap: wrap;
  font-size: 13px;
  font-weight: bold;
  justify-content: space-between;
  line-height: 1;
  padding: 8px 16px;

  span,
  p {
    flex: 0 0 auto;
  }

  p {
    margin-left: auto;
    padding-left: 1em;
  }
}

.body {
  display: grid;
  grid-auto-flow: row;
  grid-gap: 16px;
  padding: 16px;
}

hr {
  border: none;
  border-bottom: 1px solid var(--border-color);
  margin: 0 16px;
}

.required-text {
  font-weight: normal;
}
</style>
